import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Editor from '@v7/form/src/Pages/Editor';
import Home from '@v7/form/src/Pages/Home';
import Auth from '@v7/form/src/containers/Auth';
import BlockNoteRenderer from '@v7/form/src/containers/BlockNoteRenderer';
import store from '@v7/form/src/store';
import RuntimeConfigProvider from '@v7/form/src/store/runtimeConfigContext';

function App() {
  return (
    <IntlProvider locale="en">
      <RuntimeConfigProvider>
        <Provider store={store}>
          <BrowserRouter>
            <Routes>
              <Route
                path="/builder/:id"
                element={
                  <Auth>
                    <Editor />
                  </Auth>
                }
              />
              <Route
                path="/renderer/:id"
                element={
                  <Auth>
                    <BlockNoteRenderer />
                  </Auth>
                }
              />
              <Route path="/" element={<Home />} />
            </Routes>
            <ToastContainer />
          </BrowserRouter>
        </Provider>
      </RuntimeConfigProvider>
    </IntlProvider>
  );
}

export default App;
